import { provideComponent, ContentTag, WidgetTag } from 'scrivito'

import { DXPHeaderCellWidget } from './DXPHeaderCellWidgetClass'
import { alignmentClassName } from '../../../../utils/alignmentClassName'

provideComponent(DXPHeaderCellWidget, ({ widget }) => (
  <WidgetTag tag="td">
    <ContentTag
      attribute="text"
      className={alignmentClassName(widget.get('alignment'))}
      content={widget}
      tag="p"
    />
  </WidgetTag>
))
